import React, { useState, useEffect } from "react";
import { Card, Col, Row, Input, AutoComplete } from "antd";
import axios from "axios";

import { useNavigate, useLocation } from "react-router-dom";
import "./App.css"; // Import your CSS file to apply styles

const { Search } = Input;

const CompanyAnalysis = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCardClick = (message) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("question", message);
    navigate(`/?${searchParams.toString()}`);
  };

  // inside CompanyAnalysis, alongside your other handlers:
  const handleCompanyClick = (symbol) => {
    navigate(`/${symbol.toUpperCase()}`);
  };

  // invoked when user presses Enter or clicks Analyze
  // invoked when user presses Enter or clicks Analyze
  const [options, setOptions] = useState([]);
  const [searching, setSearching] = useState(false);

  const handleSearch = async (value) => {
    if (!value) return;
    setSearching(true);

    try {
      const res = await axios.get(
        `https://wmsxju1yh0.execute-api.us-east-1.amazonaws.com/prod/search?q=${encodeURIComponent(
          value
        )}&category=symbol`
      );

      const data = Array.isArray(res.data)
        ? res.data
        : typeof res.data.body === "string"
        ? JSON.parse(res.data.body)
        : [];

      const suggestions = data.map((item) => ({
        value: item.symbol,
        label: (
          <div>
            <strong>{item.symbol}</strong> – {item.company}
            <div style={{ fontSize: "12px", color: "#888" }}>{item.tags}</div>
          </div>
        ),
      }));

      setOptions(suggestions);
    } catch (err) {
      console.error("Search failed", err);
    }

    setSearching(false);
  };

  const onSelect = (value) => {
    // Open company detail page in a new tab
    window.open(`https://stockbuzz.ai/${value}`, "_blank");
  };
  // your three “popular” stocks
  const popularStocks = [
    { symbol: "TSLA", label: "Tesla" },
    { symbol: "AAPL", label: "Apple" },
    { symbol: "AMZN", label: "Amazon" },
  ];

  const renderSection = (title, items) => (
    <div
      style={{
        margin: isMobile ? "20% 5% 15%" : "5% 5% 5%",
      }}
    >
      <h2>{title}</h2>
      <Row gutter={16} style={{ display: "flex", alignItems: "stretch" }}>
        {items.map((item, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={8}
            style={{ display: "flex" }}
          >
            <Card
              title={item.title}
              bordered={false}
              style={{
                flex: 1,
                backgroundColor: "whitesmoke",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              className="card-hover-effect"
              onClick={() => handleCardClick(item.message)}
            >
              {item.description}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  return (
    <div
      style={{
        paddingTop: isMobile ? "5%" : "5%", // Adjust top padding here
        paddingBottom: isMobile ? "5%" : "5%", // Adjust bottom padding here
      }}
    >
      <div style={{ margin: isMobile ? "10% 5%" : "5% 5%" }}>
        <h2>Stock Analysis</h2>
        <AutoComplete
          options={options}
          onSelect={onSelect}
          onSearch={handleSearch}
          placeholder="Search any stock (e.g. MSFT)"
          style={{ width: "100%", marginBottom: "1rem" }}
        >
          <Input.Search
            loading={searching}
            enterButton="Analyze"
            size="large"
          />
        </AutoComplete>

        <Row gutter={16}>
          {popularStocks.map(({ symbol, label }) => (
            <Col key={symbol} xs={24} sm={12} md={8}>
              <Card
                hoverable
                title={label}
                onClick={() => handleCompanyClick(symbol)}
                className="card-hover-effect"
                style={{
                  marginBottom: "1rem",
                  backgroundColor: "whitesmoke",
                  borderRadius: 8,
                  textAlign: "center",
                }}
              >
                Analyze {label}
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      {renderSection("Single Company Analysis", [
        {
          title: "Top 7 Reasons to Buy Tesla",
          message: "What are the top 7 reasons to buy Tesla?",
          description: "Revenue growth, profitability, and market trends.",
        },
        {
          title: "Amazon Detailed Financial Analysis",
          message: "Provide a detailed financial analysis of Amazon.",
          description: "Assess revenue, costs, and profitability metrics.",
        },
        {
          title: "Latest Nvidia GPU Launches",
          message: "What are the latest GPU launches by Nvidia?",
          description: "Explore new products and market impact.",
        },
      ])}

      {renderSection("Compare Companies", [
        {
          title: "Amazon vs Microsoft Cloud",
          message: "Compare Amazon vs Microsoft Cloud services.",
          description: "Cloud revenue, growth, and market share.",
        },
        {
          title: "Nvidia vs AMD Earnings Analysis",
          message: "Analyze Nvidia and AMD latest earnings calls.",
          description: "Earnings growth and market performance.",
        },
        {
          title: "Meta vs Snapchat User Base Analysis",
          message: "Compare Meta vs Snapchat user base performance.",
          description: "User engagement, revenue, and market trends.",
        },
      ])}

      {renderSection("Valuation by DCF", [
        {
          title: "Costco Valuation Analysis",
          message: "What is the fair value of Costco?",
          description: "Estimate future cash flows and intrinsic value.",
        },
        {
          title: "Walmart Valuation",
          message: "DCF Valuation of Walmart.",
          description: "Assess financials to determine intrinsic value.",
        },
        {
          title: "Snapchat Valuation",
          message: "DCF Valuation of Snapchat.",
          description: "Review forecasted cash flows and valuation metrics.",
        },
      ])}
    </div>
  );
};

export default CompanyAnalysis;
